export const AVAILABLE_LANGUAGES = [
  { label: "English (en-US)", code: "en", value: "en" },
  { label: "Español (es-PR)", code: "es", value: "es" },
  // { label: "Polski (pl-PL)", code: "pl-PL", value: "pl-PL" },
  { label: "Français (fr-FR)", code: "fr-FR", value: "fr-FR" },
  // { label: "English-Spanish (en-US es-PR)", code: "en-es", value: "en-es" },
];

export const AVAILABLE_LANGUAGES_FOR_SCRIBE = [
  { label: "English", code: "en", value: "en" },
  { label: "Español", code: "es", value: "es", isBilingual: true },
  // { label: "Polski (pl-PL)", code: "pl-PL", value: "pl-PL" },
  { label: "Français", code: "fr-FR", value: "fr-FR", isBilingual: true },
  // { label: "English-Spanish (en-US es-PR)", code: "en-es", value: "en-es" },
];

export const AVAILABLE_LANGUAGES_CLINICAL_NOTE = [
  { label: "English", code: "en", value: "English" },
  { label: "Español", code: "es", value: "Spanish" },
  // { label: "Polski (pl-PL)", code: "pl-PL", value: "pl-PL" },
  { label: "Français", code: "fr-FR", value: "French" },
  // { label: "English-Spanish (en-US es-PR)", code: "en-es", value: "en-es" },
];